import { useAuthenticated } from "nate-react-api-helpers";
export function useCurrentUser() { var auth = useAuthenticated(); return auth.lastPingResult; }
export function useRole() { var u = useCurrentUser(); return u === null || u === void 0 ? void 0 : u.role; }
export function useIsOfficeManager() { return useRole() === "office_manager"; }
export function useIsProjectManager() { return useRole() === "project_manager"; }
export function useIsMechanic() { return useRole() === "mechanic"; }
export function useIsOfficeAdmin() { return useRole() === "office_admin"; }
